module.exports = __webpack_public_path__ + "static/media/frank_ayars.9e7759d4.png";